export const linkLikehoverHandlingClasses =
  'duration-300 transition-all cursor-pointer underline hover:!text-ossio-green duration-300 transition-all hover:no-underline';
